import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../../redux/slices/authSlice";
import pendingUserReducer from "../../redux/slices/pendingUserSlice";
import profileReducer from "../../redux/slices/profileSlice";

import companyRoleReducer from "../../redux/slices/companyRoleSlice";

import pointExchangeRateReducer from "../../redux/slices/pointExchangeRateSlice";
import mlmTreeLevelReducer from "../../redux/slices/mlmTreeLevelSlice";
import mlmTreeReducer from "../../redux/slices/mlmTreeSlice";
import officeReducer from "../../redux/slices/officeSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    pendingUsers: pendingUserReducer,
    profile: profileReducer,
    companyRole: companyRoleReducer,

    pointExchangeRates: pointExchangeRateReducer,
    mlmTreeLevels: mlmTreeLevelReducer,
    mlmTree: mlmTreeReducer,
    offices: officeReducer,
  },
});

export default store;
